import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=748c8175&scoped=true"
import script from "./Collect.vue?vue&type=script&lang=js"
export * from "./Collect.vue?vue&type=script&lang=js"
import style0 from "./Collect.vue?vue&type=style&index=0&id=748c8175&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c8175",
  null
  
)

export default component.exports